import { ISharePluginPC } from '@src/slide/application/no-edit/plugins/share/base/pc/share-plugin-pc.interface';
import { ScriptLoader } from '@src/slide/application/service/edit-extension/edit-extension-export';
import SharePluginBase from '@src/slide/application/no-edit/plugins/share/toc/base/share-plugin-base';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { IPcEditorExtensionService } from '@src/slide/application/service/edit-extension/core/editor/pc/interface';
import { AUTH_PC_PLUGIN_CONFIG_NAME } from '@src/slide/application/no-edit/plugins/auth/constants';

export default class SharePluginPC extends SharePluginBase implements ISharePluginPC {
    declare protected editExtensionService?: IPcEditorExtensionService;
    private shareModule: any;

    public show(onAuthUpdated?: (info: any) => void): void {
        if (this.shareModule) {
            this.showShare(false, onAuthUpdated);
        } else {
            // @ts-ignore
            ScriptLoader.load('Share', (Share) => {
                this.shareModule = Share;
                this.showShare(true, onAuthUpdated);
            });
        }
    }

    public hide(): void {
        if (this.shareModule) {
            this.shareModule.hide();
        } else {
            // @ts-ignore
            ScriptLoader.load('Share', (Share) => {
                this.shareModule = Share;
                this.shareModule.hide();
            });
        }
    }

    protected getAuthPluginName(): string {
        return AUTH_PC_PLUGIN_CONFIG_NAME;
    }

    private showShare(needInit, onAuthUpdated): void {
        if (this.editExtensionService?.getDisplayRightSlideBarName() === 'auth') {
            this.editExtensionService?.hideRightSideBar();
        }
        this.showOrHideContainer(true);
        if (needInit) {
            const {
                domainId,
                padId, creatorDomain, isCreator, padType: shareDocType } = SlideDataServices.DocInfoManager() ?? {};
            const shareTitle = function () {
                return SlideDataServices.SlideTitleManager()?.title;
            };
            /**
             * 是否能修改权限
             */
            const havePermission = isCreator;
            const shareLink = this.getShareLink();
            this.shareModule.init(document.getElementById('doc-sharebox-container'), {
                invokeFrom: 'detail',
                padId,
                shareLink,
                shareTitle,
                shareDocType,
                domainId,
                creatorDomain,
                havePermission,
                onAuthUpdated: (info) => {
                    onAuthUpdated?.(info);
                },
                onClose: () => {
                    this.showOrHideContainer(false);
                },
            });
        } else {
            this.shareModule.show({
                onAuthUpdated: (info) => {
                    onAuthUpdated?.(info);
                },
                onClose: () => {
                    this.showOrHideContainer(false);
                },
            });
        }
    }

    private showOrHideContainer(show: boolean): void {
        const container = document.getElementById('doc-sharebox-container');
        if (container) {
            container.style.display = show ? 'block' : 'none';
        }
    }
}
